let elem = document.querySelector(".carousel.product__image-slider");
let productThumbGallery;
let productMainGallery;

if (elem) {
  productThumbGallery = new Swiper(".carousel.product__image-thumbnail", {
    spaceBetween: 10,
    slidesPerView: "auto",
    watchSlidesProgress: true,
  });

  // The product badge is positioned over the whole gallery, so it would sit on
  // top of every slide. Only show it while the first image is in view.
  const mediaWrapper = elem.closest(".product__media-wrapper");
  const syncBadge = (swiper) => {
    if (!mediaWrapper) return;
    mediaWrapper.classList.toggle("is-not-first-slide", swiper.activeIndex !== 0);
  };

  productMainGallery = new Swiper(".carousel.product__image-slider", {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: ".product__image-slider-wrapper .swiper-button-next",
      prevEl: ".product__image-slider-wrapper .swiper-button-prev",
    },
    thumbs: {
      swiper: productThumbGallery,
    },
    mousewheel: {
      forceToAxis: true,
    },
    on: {
      init: syncBadge,
      slideChange: syncBadge,
    },
  });
}
